// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"471":"94538a0b","478":"7aca54c7"}[chunkId] + ".chunk.css";
};